<template>
  <NuxtLink
    v-if="tag === 'NuxtLink'"
    class="c-base-button"
    :class="{
      'c-base-button--not-a-button': notAButton,
    }"
    :to="to"
  >
		<slot></slot>
	</NuxtLink>
	<Component
    v-else
    :is="tag"
    class="c-base-button"
    :class="{
      'c-base-button--not-a-button': notAButton,
    }"
    :to="to"
  >
		<slot></slot>
	</Component>
</template>

<script setup>
const props = defineProps({
	tag: {
		type: String,
		default: 'button',
	},
	to: {
		type: [String, Object],
		default: null,
	},
  notAButton: Boolean,
});

const tag = computed(() => {
	if (props.tag && props.tag !== 'button') {
		return props.tag;
	}
	if (props.to) {
		return 'NuxtLink';
	}
	return 'button';
});
</script>

<style lang="postcss">
.c-base-button {
	@apply inline-flex justify-center items-center w-fit px-[15px] py-[8px] rounded-[3px];
	@apply bg-green text-text font-bold text-16;
	@apply transition duration-200;
}
.c-base-button:where(:not(.c-base-button--not-a-button)) {
  @apply hover:bg-green-dark cursor-pointer;

  &:active {
    transform: scale(0.95);
  }
}
.c-base-button:where([aria-disabled='true']) {
	@apply text-opacity-50 bg-green bg-opacity-30 !important;
}
</style>
